// extracted by mini-css-extract-plugin
module.exports = {"image":"about_image__29a0R","title":"about_title__3Itsc","description":"about_description__23bkA"};